import { useEffect, useRef } from 'react';

/**
 * Hooks for combining refs. Used in forwardRef component when we need to merge ref and innerRef
 * @param refs
 * @returns
 */
// TODO Typing
export const useCombinedRefs = (...refs: any[]) => {
  const targetRef = useRef(null);

  useEffect(() => {
    refs.forEach((ref) => {
      if (!ref) return;

      if (typeof ref === 'function') {
        ref(targetRef.current);
      } else {
        ref.current = targetRef.current;
      }
    });
  }, [refs]);

  return targetRef;
};
